var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "back",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17174",
    "data-name": "Rectangle 17174",
    width: 16,
    height: 16,
    transform: "translate(0)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back-svgrepo-com",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28005",
    "data-name": "Path 28005",
    d: "M192.7,480H206.6a.7.7,0,0,1,0,1.4H192.7a.7.7,0,0,1,0-1.4Z",
    transform: "translate(-191.297 -473.745)",
    fill: "#168c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28006",
    "data-name": "Path 28006",
    d: "M161.639,198.916l5.824,5.768a.692.692,0,0,1,0,.985.708.708,0,0,1-.994,0l-6.319-6.26a.691.691,0,0,1,0-.985l6.319-6.26a.708.708,0,0,1,.994,0,.692.692,0,0,1,0,.985Z",
    transform: "translate(-159.943 -191.96)",
    fill: "#168c98"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.1d3bedcdf5ea8c585c47d9dff8d8c0a1.svg";
export { ForwardRef as ReactComponent };